import http from 'plugins/axios';

export default {
  getaward(data) {
    return http.get({
      url: '/la/admin/purchase/getAllBallot',
      data
    });
  },
  confirmGitNum(data) {
    return http.post({
      url: '/la/admin/purchase/confirmGitNum',
      data,
      dataType: 'form'
    });
  },
  confirmOne(data) {
    return http.post({
      url: '/la/admin/purchase/sendGitOne',
      data,
      dataType: 'form'
    });
  },
  confirmMore(data) {
    return http.post({
      url: '/la/admin/purchase/sendGitAll',
      data,
      dataType: 'form'
    });
  }
};
